import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({baseUrl: process.env.ENV === 'dev' ? 'http://localhost:1337/api' : process.env.PARCEL_API_URL}),
    endpoints: (builder) => ({
        //* - - - - - - - - - - - - - - - - - - - - - - - - Creation APIs
        whakamohioMai: builder.mutation({
            query: (body) => ({
                url: "/tapiriImera",
                method: 'POST',
                body
            })
        }),
        pataiHou: builder.mutation({ 
            query: (body) => ({
                url: "/pataiHou",
                method: 'POST',
                body
            })
        }),
        //* - - - - - - - - - - - - - - - - - - - - - - - - Read APIs
        patai: builder.query({
            query: () => `patai`,
        })
    }),
})

export default api.reducer;
export const { 
    useWhakamohioMaiMutation, 
    usePataiHouMutation, 
    usePataiQuery, 
} = api;
